export const isExperimental = process.env.REACT_APP_EXPERIMENTAL_MODE === 'true';
